// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__3PfOt","footerWrapper":"Footer_footerWrapper__17UfG"};